import { blockByID, blockCreate, blockDestroy, blockList, blockUpdate } from '@/services/wallBlocks.service'

export default {
	namespaced: true,
	state: {
		// SERVICE BLOCK
		blockList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		block: {},

		// STATUS SERVICE BLOCK
		blockStatus: 'pending',
		blockSaveStatus: 'init',
		blockDeleteStatus: 'init',
	},
	getters: {
		// SERVICE BLOCK
		getBlockList(state) {
			return state.blockList
		},
		getBlock(state) {
			return state.block
		},

		// SERVICE STATUS
		getStatusList(state) {
			return state.statusList
		},
		getStatus(state) {
			return state.status
		},

		// SERVICE BLOCK
		getBlockDeleteStatus(state) {
			return state.blockDeleteStatus
		},
		getBlockSaveStatus(state) {
			return state.blockSaveStatus
		},
		getBlockStatus(state) {
			return state.blockStatus
		},
	},
	mutations: {
		// SERVICE BLOCK
		BLOCK_LIST(state, value) {
			state.blockList = value
		},
		SET_BLOCK(state, value) {
			state.block = value
		},

		// STATUS SERVICE BLOCK
		BLOCK_STATUS(state, value) {
			state.blockStatus = value
		},
		BLOCK_SAVE_STATUS(state, value) {
			state.blockSaveStatus = value
		},
		BLOCK_DELETE_STATUS(state, value) {
			state.blockDeleteStatus = value
		},
	},
	actions: {
		// Service Block
		async fetchBlockList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('BLOCK_STATUS', 'pending')
			commit('BLOCK_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await blockList(params)
				commit('BLOCK_STATUS', 'init')
				commit('BLOCK_LIST', data)
				return data
			} catch (error) {
				commit('BLOCK_STATUS', 'init')
				throw error
			}
		},
		async fetchBlockByID({ commit }, params) {
			commit('BLOCK_STATUS', 'pending')
			try {
				const { data } = await blockByID(params)
				commit('BLOCK_STATUS', 'init')
				commit('SET_BLOCK', data.data)
				return data
			} catch (error) {
				commit('BLOCK_STATUS', 'init')

				return error
			}
		},
		async saveNewBlock({ commit }, params) {
			commit('BLOCK_SAVE_STATUS', 'pending')
			try {
				const { data } = await blockCreate(params)
				commit('BLOCK_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('BLOCK_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateBlock({ commit }, params) {
			commit('BLOCK_SAVE_STATUS', 'pending')
			try {
				const { data } = await blockUpdate(params)
				commit('BLOCK_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('BLOCK_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteBlockByID({ commit }, params) {
			commit('BLOCK_DELETE_STATUS', 'pending')
			try {
				const { data } = await blockDestroy(params)
				commit('BLOCK_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('BLOCK_DELETE_STATUS', 'error')

				return error
			}
		},
	},
}
